import { useSnackbar } from "notistack"

const InnerSnackbarUtilsConfigurator = props => {
  props.setUseSnackbarRef(useSnackbar())
  return null
}

let useSnackbarRef
const setUseSnackbarRef = useSnackbarRefProp => {
  useSnackbarRef = useSnackbarRefProp
}

export const SnackbarUtilsConfigurator = () => {
  return (
    <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />
  )
}

export default function toast(msg, options = {}) {
  console.log('toast',msg)
  useSnackbarRef.enqueueSnackbar(msg, options)
}
